module.exports = __webpack_public_path__ + "img/2021_1_10_screamer.f6258b84.jpg";